"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
/**
 * @license
 * Copyright 2017 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {
  CREDENTIALS_PROVIDER_RPC_ID,
  CREDENTIALS_PROVIDER_GET_RPC_ID,
  CREDENTIALS_MANAGER_RPC_ID,
  CREDENTIALS_MANAGER_GET_RPC_ID
} from "#src/credentials_provider/shared_common.js";
import {
  registerPromiseRPC,
  registerSharedObjectOwner,
  SharedObject
} from "#src/worker_rpc.js";
export let SharedCredentialsProvider = class extends SharedObject {
  constructor(provider, rpc) {
    super();
    this.provider = provider;
    this.registerDisposer(provider);
    this.initializeCounterpart(rpc);
  }
  get(invalidCredentials, options) {
    return this.provider.get(invalidCredentials, options);
  }
};
SharedCredentialsProvider = __decorateClass([
  registerSharedObjectOwner(CREDENTIALS_PROVIDER_RPC_ID)
], SharedCredentialsProvider);
registerPromiseRPC(
  CREDENTIALS_PROVIDER_GET_RPC_ID,
  function(x, progressOptions) {
    const obj = this.get(x.providerId);
    return obj.get(x.invalidCredentials, progressOptions).then((credentials) => ({
      value: credentials
    }));
  }
);
export let SharedCredentialsManager = class extends SharedObject {
  constructor(base, rpc) {
    super();
    this.base = base;
    this.initializeCounterpart(rpc);
  }
  getCredentialsProvider(key, parameters) {
    return this.base.getCredentialsProvider(key, parameters);
  }
};
SharedCredentialsManager = __decorateClass([
  registerSharedObjectOwner(CREDENTIALS_MANAGER_RPC_ID)
], SharedCredentialsManager);
registerPromiseRPC(
  CREDENTIALS_MANAGER_GET_RPC_ID,
  async function(x, progressOptions) {
    const manager = this.get(x.managerId);
    const provider = manager.base.getCredentialsProvider(x.key, x.parameters);
    const credentials = await provider.get(
      x.invalidCredentials,
      progressOptions
    );
    return { value: credentials };
  }
);
